// @flow
import type { SignUpOrderActionType } from './actions';
import type { StateType } from '../../reducers';

export type SignUpOrderStateType = {|
  uuid?: ?string,
  state: ?string,
|};

export const initialState: SignUpOrderStateType = {
  state: null,
};

export default (state: SignUpOrderStateType = initialState, action: SignUpOrderActionType) => {
  switch (action.type) {
    case 'SIGNUP_SET_ORDER_UUID':
      return {
        ...state,
        ...action.payload,
      };

    case 'SIGNUP_SET_ORDER_STATE_FOR_UUID':
      return {
        ...state,
        ...action.payload,
      };

    default:
      return state;
  }
};

const signUpOrderStateSelector = (state: StateType) => state.signUp && state.signUp.order;

export const orderUuidSelector = (state: StateType): ?string => {
  const order = signUpOrderStateSelector(state);
  return order && order.uuid;
};

export const orderStateSelector = (state: StateType): ?string => {
  const order = signUpOrderStateSelector(state);
  return order && order.state;
};
